var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPallete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 10C3 13.866 6.13401 17 10 17C11.1598 17 12.1 16.0598 12.1 14.9V14.55C12.1 14.2249 12.1 14.0624 12.118 13.9259C12.242 12.9836 12.9836 12.242 13.9259 12.118C14.0624 12.1 14.2249 12.1 14.55 12.1H14.9C16.0598 12.1 17 11.1598 17 10C17 6.13401 13.866 3 10 3C6.13401 3 3 6.13401 3 10Z",
    stroke: "#123B47",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 10.7C6.8866 10.7 7.2 10.3866 7.2 10C7.2 9.6134 6.8866 9.3 6.5 9.3C6.1134 9.3 5.8 9.6134 5.8 10C5.8 10.3866 6.1134 10.7 6.5 10.7Z",
    stroke: "#123B47",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8 7.9C13.1866 7.9 13.5 7.5866 13.5 7.2C13.5 6.8134 13.1866 6.5 12.8 6.5C12.4134 6.5 12.1 6.8134 12.1 7.2C12.1 7.5866 12.4134 7.9 12.8 7.9Z",
    stroke: "#123B47",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6 7.2C8.9866 7.2 9.3 6.8866 9.3 6.5C9.3 6.1134 8.9866 5.8 8.6 5.8C8.2134 5.8 7.9 6.1134 7.9 6.5C7.9 6.8866 8.2134 7.2 8.6 7.2Z",
    stroke: "#123B47",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPallete);
export default __webpack_public_path__ + "f6aca4bed8ea09ea5cd2d1fceff6581e.svg";
export { ForwardRef as ReactComponent };